import styled from "styled-components";
// theme
import { typography } from "src/theme";
import { colors } from "src/theme/colors";
import device from "src/constants/media";

export const Wrapper = styled.div``;
export const Content = styled.div`
  display: flex;
  margin-bottom: 280px;
  margin-top: 120px;
  padding: 24px;
  position: relative;
  @media ${device.mobileL} {
    margin-top: 56px;
    margin-bottom: 96px;
  }
  @media ${device.laptop} {
    margin-top: 96px;
    margin-bottom: 280px;
  }
  @media ${device.laptopS} {
    padding: 0;
    margin-inline: auto;
    margin-top: 96px;
    width: 1096px;
  }
`;
export const RequestSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  z-index: 1;

  @media ${device.tablet} {
    gap: 48px;
  }
`;
export const DropdownSection = styled.div`
  display: block;

  @media ${device.laptop} {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
export const Text = styled.div`
  margin: 16px 0;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.mainLight};

  @media ${device.laptop} {
    margin: 0 24px;
  }
`;
export const ImageWrapper = styled.div`
  right: -440px;
  top: 300px;
  position: absolute;
  pointer-events: none;
  @media ${device.mobileL} {
    right: -280px;
    top: 280px;
  }
  @media ${device.tablet} {
    right: -240px;
    top: 144px;
  }
  @media ${device.laptopS} {
    right: -140px;
  }
`;
